import ipRangeCheck from 'ip-range-check';
import testingIPsList from '../consts/testingIPsList.json';

const testingIpList: string[] = [
  ...testingIPsList.prefixes.map((item: object) => Object.values(item)[0]),
];

export const isTestUser = (ip_address?: string): boolean | null => {
  if (!ip_address) return null;

  return ipRangeCheck(ip_address, testingIpList);
};
